// Magazines: a six-chamber toy cylinder (Six-Spinner), a pea hopper (Pea Pistol) or a ridged pump tube
// under the barrel (Pump Boomer).
import { detailStroke, fillP, type Part } from '../../passes.ts';
import { circle, line } from '../../shapes.ts';
import { type GunKit, lrect } from './types.ts';

/** Six-Spinner chamber colours (6-colour toy revolver; all outside the blaze hue band). */
const CHAMBERS = ['tier.2', 'tier.4', 'confetti.3', 'tier.8', 'tier.7', 'glow.select'];

export function magazine(g: GunKit): Part[] {
  const { kind } = g.r.mag;
  const rc = g.r.receiver;
  if (kind === 'cylinder6') {
    const x = rc.x + rc.w * 0.42;
    const w = 20;
    return [
      lrect(g, g.r.second, x, rc.y - 3, w, rc.h + 6, 6, {
        detail: (c) => {
          CHAMBERS.slice(0, 3).forEach((tok, i) => {
            const cy = rc.y + 1 + (i * (rc.h + 1)) / 3 + (rc.h + 1) / 6;
            fillP(c, circle(x + w / 2, cy, 3.4), g.pal.sw(tok).base);
          });
        },
      }),
    ];
  }
  if (kind === 'hopper') {
    const cx = rc.x + rc.w * 0.45;
    const cy = rc.y - 9;
    return [
      lrect(g, g.r.accent, cx - 11, cy - 11, 22, 22, 11, {
        detail: (c) => {
          for (const [dx, dy] of [
            [-4, 2],
            [4, 3],
            [0, -4],
          ] as const) {
            fillP(c, circle(cx + dx, cy + dy, 3.2), g.pal.sw('tier.2').base);
          }
        },
      }),
    ];
  }
  if (kind === 'pump') {
    const { x, len, th } = g.r.barrel;
    const sw = g.pal.sw(g.r.gripTok);
    return [
      lrect(g, g.r.gripTok, x + 4, th / 2 - 2, len * 0.62, 11, 4, {
        detail: (c) => {
          for (let i = 1; i < 6; i++) {
            const fx = x + 4 + (len * 0.62 * i) / 6;
            detailStroke(
              c,
              line([
                [fx, th / 2 + 1],
                [fx, th / 2 + 7],
              ]),
              sw.light,
              g.ow * 0.6,
            );
          }
        },
      }),
    ];
  }
  return [];
}
